export type Article = {
  acf: {
    images: any;
  };
  date_gmt: string;
  id: string;
  slug: string;
  title: { rendered: string };
  type: string;
  _embedded: any;
};
